// extracted by mini-css-extract-plugin
export default {"Label":"InfosPasswordLabels_Label__6vRLJ"};